<template>
  <div id="app">
    <!-- 页面切换动画 -->
    <transition name="page-fade" mode="out-in">
      <router-view />
    </transition>
  </div>
</template>

<script>
import i18n from "./utils/i18n";
import auth from "./utils/auth";
import websiteTitleManager from "./utils/websiteTitle";

export default {
  name: "App",
  created() {
    // 初始化应用状态
    this.initializeApp();
  },
  mounted() {
    // 应用挂载后检查用户状态并进行智能跳转
    this.handleInitialNavigation();
    // 加载网站标题
    this.loadWebsiteTitle();
  },
  methods: {
    /**
     * 初始化应用
     * 恢复用户会话和语言设置
     */
    initializeApp() {
      // 初始化语言设置
      const savedLanguage = i18n.getLanguage();
      if (savedLanguage) {
        i18n.setLanguage(savedLanguage);
      }

      // 恢复用户登录状态
      const currentUser = auth.getCurrentUser();
      if (currentUser) {
        console.log("User logged in:", currentUser.username);
      }

      // 初始化认证系统（创建默认管理员账户）
      auth.init();
    },

    /**
     * 处理应用启动时的智能导航
     * 所有用户默认进入Home页面
     */
    handleInitialNavigation() {
      const currentUser = auth.getCurrentUser();
      const currentRoute = this.$route.path;

      // 如果用户已登录且在登录/注册页面，跳转到首页
      if (
        currentUser &&
        (currentRoute === "/login" || currentRoute === "/register")
      ) {
        this.$router.replace("/");
      }
    },

    /**
     * 加载网站标题
     * 使用全局标题管理器加载标题
     */
    async loadWebsiteTitle() {
      try {
        const title = await websiteTitleManager.loadTitle();
        // 将标题存储到全局状态中，供其他组件使用
        this.$root.websiteTitle = title;
      } catch (error) {
        console.error("加载网站标题失败:", error);
      }
    },
  },
};
</script>

<style>
/* 全局样式重置 - 移除浏览器默认的 margin 和 padding */
html,
body {
  margin: 0;
  padding: 0;
  width: 100%;
  height: 100%;
  overflow-x: hidden;
  -ms-overflow-style: none;
  scrollbar-width: none;
}

html::-webkit-scrollbar,
body::-webkit-scrollbar {
  display: none;
}

/* 只添加最基本的容器样式 */
#app {
  width: 100%;
  height: 100%;
  margin: 0;
  padding: 0;
}

/* 页面切换动画 */
.page-fade-enter-active,
.page-fade-leave-active {
  transition: opacity 0.3s ease, transform 0.3s ease;
}

.page-fade-enter {
  opacity: 0;
  transform: translateX(10px);
}

.page-fade-leave-to {
  opacity: 0;
  transform: translateX(-10px);
}
</style>
